export const domainKeys = {
	options: ["domains", "options"],
};
